import React, { useState } from "react";
import "./toast.css";
import Toast from "./Toast";
import useEventListener from "../../utils/hooks/useEventListener";
import useToast, { TOAST_ACTIONS, TOAST_TYPES } from "../../utils/hooks/useToast";
import { ICONS } from "../../utils/constants/ICONS";

export default function Toasts() {
  const [toasts, setToasts] = useState([]);
  const [addToast] = useToast();

  // Listen for toast-add event
  useEventListener(TOAST_ACTIONS.ADD, (e) => {
    setToasts((prev) => [
      {
        type: e.detail.type,
        message: e.detail.message,
        duration: e.detail.duration || e.detail.type === TOAST_TYPES.ERROR ? 1000000 : 5000,
        id: parseInt(Math.random(1) * 1000),
      },
      ...prev,
    ]);
  });

  // Listen for toast-remove event
  useEventListener(TOAST_ACTIONS.REMOVE, (e) => {
    setToasts((prev) => {
      const newToasts = [...prev];
      const index = newToasts.findIndex((t) => t.id === e.detail.id);
      newToasts.splice(index === -1 ? toasts.length : index, 1);
      return newToasts;
    });
  });

  // useEffect(() => {
  //   addToast(TOAST_TYPES.ERROR, "Test error");
  // }, [addToast]);

  return (
    <div data-isopen={toasts.length > 0} className="toasts-container">
      <button
        className="toasts-clear-all"
        onClick={() => setToasts([])}
        data-isopen={toasts.length > 1}
      >
        Clear all {ICONS.X}
      </button>
      {toasts.map((toast) => (
        <Toast key={toast.id} toast={toast} />
      ))}
    </div>
  );
}